/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIChannel } from './APIChannel';
import {
    APIChannelFromJSON,
    APIChannelFromJSONTyped,
    APIChannelToJSON,
} from './APIChannel';

/**
 * 
 * @export
 * @interface APIPaginatedChannelList
 */
export interface APIPaginatedChannelList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedChannelList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedChannelList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedChannelList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIChannel>}
     * @memberof APIPaginatedChannelList
     */
    results: Array<APIChannel>;
}

/**
 * Check if a given object implements the APIPaginatedChannelList interface.
 */
export function instanceOfAPIPaginatedChannelList(value: object): value is APIPaginatedChannelList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedChannelListFromJSON(json: any): APIPaginatedChannelList {
    return APIPaginatedChannelListFromJSONTyped(json, false);
}

export function APIPaginatedChannelListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedChannelList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIChannelFromJSON)),
    };
}

export function APIPaginatedChannelListToJSON(value?: APIPaginatedChannelList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIChannelToJSON)),
    };
}

